module.exports = __WEBPACK_EXTERNAL_MODULE__mq_aurora_components_dist_menu__;